function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAhu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 3",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 82 82",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("polygon", {
    points: "16.49 35.22 18.49 35.22 18.49 18.29 11.85 18.29 17.51 8.85 24.61 20.18 26.31 19.12 17.47 5.02 8.31 20.29 16.49 20.29 16.49 35.22",
    style: {
      fill: "currentColor",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "40.25 35.22 42.25 35.22 42.25 18.29 35.6 18.29 41.27 8.85 48.37 20.18 50.06 19.12 41.23 5.02 32.07 20.29 40.25 20.29 40.25 35.22",
    style: {
      fill: "currentColor",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "64 35.22 66 35.22 66 18.29 59.36 18.29 65.02 8.85 72.12 20.18 73.81 19.12 64.98 5.02 55.82 20.29 64 20.29 64 35.22",
    style: {
      fill: "currentColor",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71,55.39l-59,0c-2.35,0-5.81-3.72-5.81-7.06,0-3.57,2.93-7.21,5.81-7.21H75.71v-2H12c-4.4,0-7.81,5-7.81,9.21S8.37,57.43,12,57.43l59,0c2.88,0,5.81,3.64,5.81,7.2,0,3.35-3.46,7.07-5.81,7.07l-62.89,0v2l62.89,0c3.65,0,7.81-4.83,7.81-9.07S75.43,55.39,71,55.39Z",
    style: {
      fill: "currentColor",
      stroke: "none"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAhu);
export default __webpack_public_path__ + "static/media/ahu.111c60d1fe54967bcf476ebfdebe9518.svg";
export { ForwardRef as ReactComponent };